import { render } from "./Admin.Shop.Products.vue?vue&type=template&id=32b600d1"
import script from "./Admin.Shop.Products.vue?vue&type=script&lang=js"
export * from "./Admin.Shop.Products.vue?vue&type=script&lang=js"

import "./Admin.Shop.Products.vue?vue&type=style&index=0&id=32b600d1&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__